@if(eventClasses) {
  <div class="card card-flush">
    <div class="card-header mt-5">
      <div class="card-title flex-column">
        <h3 class="fw-bold mb-1">Event Classes</h3>
        <div class="fs-6 text-gray-500">Total number of classes {{ eventClasses.length }}</div>
      </div>
      <div class="card-toolbar my-1">
        <app-button
          [variant]="'primary'"
          [label]="'Add Class'"
          [iconClass]="'fa fa-plus'"
          [size]="'md'"
          class="ms-2"
          (clicked)="openAddEventClassModal()"
        />
      </div>
    </div>
    <div class="card-body pt-0">
      <div class="table-responsive">
        <table id="kt_profile_overview_table" class="table table-row-bordered table-row-dashed gy-4 align-middle fw-bold">
          <thead class="fs-7 text-gray-500 text-uppercase">
          <tr>
            <th class="min-w-250px">Name</th>
            <th class="min-w-90px">Start time</th>
            <th class="min-w-90px">Time per participant</th>
            <th class="min-w-50px ">Price</th>
            <th class="min-w-50px ">Number of registrations</th>
            <th class="min-w-150px">Status</th>
            <th class="text-end min-w-70px">Actions</th>
          </tr>
          </thead>
          <tbody class="fs-6">
            @for (class of eventClasses; track class.event_class_id) {
              <tr class="cursor-pointer" (click)="openViewRegistrationsModal(class)">
                <td>
                  <div class="d-flex align-items-center">
                    <div class="d-flex flex-column justify-content-center">
                      <span class="fs-6 text-gray-800">{{ class.class_name }}</span>
                      <div class="fw-semibold text-gray-500">{{ class.class?.class_name }}</div>
                    </div>
                  </div>
                </td>
                <td>{{ formatTimeDMYHHMM(class.start_date_time!) }}</td>
                <td>{{ class.time_per_participant_seconds }} sek</td>
                <td>{{ class.price }} {{class.price_currency}}</td>
                <td>{{ class.event_class_registrations.length }}</td>
                <td (click)="$event.stopPropagation()">
                  <app-selectorini
                    [options]="EVENT_CLASS_STATUSES"
                    [displayKey]="'labelKey'"
                    [multiple]="false"
                    [value]="class.status"
                    (valueChange)="updateEventClassStatus(class, $event)"
                  />
                </td>
                <td class="text-end" (click)="$event.stopPropagation()">
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-icon btn-light btn-active-light-primary"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                    >
                      <i class="fa fa-ellipsis-v"></i>
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end">
                      <li>
                        <a class="dropdown-item" (click)="openViewRegistrationsModal(class)">
                          <i class="far fa-eye me-2"></i>
                          View Registrations
                        </a>
                      </li>
                      <li>
                        <a class="dropdown-item" (click)="openEditEventClassModal(class)">
                          <i class="far fa-edit me-2"></i>
                          Edit Class
                        </a>
                      </li>
                      <li><hr class="dropdown-divider"></li>
                      <li>
                        <a class="dropdown-item text-danger" (click)="deleteEventClass(class)">
                          <i class="far fa-trash-can me-2"></i>
                          Delete Class
                        </a>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
